import React from "react";

const Button = ({
                    children,
                    variant = 'primary',
                    disabled = false,
                    type = 'button',
                    dataValue = '',
                    onClick,
                    className = ''
                }) => {
    const baseStyles = 'flex items-center px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

    const variants = {
        primary: 'bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-blue-500',
        secondary: 'bg-gray-200 hover:bg-gray-300 text-gray-900 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white focus:ring-gray-500',
        danger: 'bg-red-500 hover:bg-red-600 text-white focus:ring-red-500',
        success: 'bg-green-500 hover:bg-green-600 text-white focus:ring-green-500',
        yellow: 'bg-yellow-500 hover:bg-yellow-600 text-black focus:ring-yellow-500',
        ghost: 'hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300'
    };

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            data-value={dataValue}
            className={`${baseStyles} ${variants[variant]} ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;
